"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./sass/dropdown.scss");

var _excluded = ["id", "label", "value", "color", "disabled", "className", "options", "onChange", "size", "defaultValue"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dropdown = function Dropdown(_ref) {
  var _dropDownClasses;

  var id = _ref.id,
      label = _ref.label,
      value = _ref.value,
      color = _ref.color,
      disabled = _ref.disabled,
      className = _ref.className,
      options = _ref.options,
      onChange = _ref.onChange,
      size = _ref.size,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, _excluded);

  var dropDownClasses = (_dropDownClasses = {}, _defineProperty(_dropDownClasses, "dropdown", true), _defineProperty(_dropDownClasses, "dropdown--".concat(size), size), _defineProperty(_dropDownClasses, "dropdown--".concat(color), color), _defineProperty(_dropDownClasses, "dropdown--disabled", disabled), _defineProperty(_dropDownClasses, className, className), _dropDownClasses);

  var renderOptions = function renderOptions() {
    if (options) {
      var opts = options;

      if (opts.length && _typeof(opts[0]) !== 'object') {
        opts = options.map(function (option) {
          return {
            value: option,
            label: option
          };
        });
      }

      return opts.map(function (opt) {
        return /*#__PURE__*/_react.default.createElement("option", {
          value: opt.value,
          disabled: opt.disabled,
          key: opt.value
        }, opt.label);
      });
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(dropDownClasses)
  }, label ? /*#__PURE__*/_react.default.createElement("p", {
    className: "dropdown-label"
  }, label) : null, /*#__PURE__*/_react.default.createElement("select", _extends({
    id: id,
    value: value,
    defaultValue: defaultValue,
    name: id,
    onChange: onChange,
    disabled: disabled
  }, props), renderOptions()));
};

Dropdown.propTypes = {
  color: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  label: _propTypes.default.any,
  onChange: _propTypes.default.func,
  options: _propTypes.default.array,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  value: _propTypes.default.string
};
Dropdown.defaultProps = {
  id: null,
  color: 'default',
  label: null,
  onChange: null,
  size: 'medium',
  value: undefined,
  disabled: false,
  className: '',
  options: [{
    value: 'text',
    label: 'label'
  }]
};
var _default = Dropdown;
exports.default = _default;